/* eslint-disable prettier/prettier */
interface SummaryCard {
  title: string;
  value: number | string;
  icon?: React.ReactNode;
}

export const DashboardSummaryCards = ({ cards }: { cards: SummaryCard[] }) => {
  return (
    <div className="grid grid-cols-2 gap-8 mb-8 lg:grid-cols-4 ">
      {cards.map((card, index) => (
       <div
          key={index}
          className="flex items-center p-5 bg-white border-2 rounded-lg shadow-md border-muted py-7"
        >
          <div className="flex items-center justify-center w-12 h-12 mr-5 rounded-full text-primary bg-muted">
            {card.icon}
          </div>
          <div className="flex flex-col justify-center">
            <p className="text-2xl font-semibold leading-tight text-primary">{card.value}</p>
            <p className="text-sm text-muted-foreground">{card.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
